import React from 'react'
import {  Tooltip } from 'antd';
import { Link } from "react-router-dom";
import ReactContext from "@store/reactContext";
import "./indexTips.less";
/**
 * 权限按钮
 * 图标划过 交互组件 带提示信息
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * @param icon  结合 remixicon，对应UI上的图标
 * @param linkTo 承接Link 中 TO的内容
 * @param onClick 点击事件
 * @param className : 配置blueIconTips 蓝色的背景，默认灰底
 * @param showDot 头部显示红点
 */
import {isEmpty} from "@utils/utils";
// 渲染按钮
const btn = (icon,fontSize,onClick=null,className="",title=null,showDot=false) =>{
    return (<span className={`hoverIconTips${className?" "+className:""}`} onClick={()=>onClick?onClick():null}>
        {showDot?<span className={"showDot"} />:null}
        {icon?<i className={icon} style={{ fontSize: fontSize}}></i>:""}
        {title}
    </span>)
}
// 跳转或按钮
const renderCont = (linkTo,target,icon,fontSize,onClick,className,title,showDot) =>{
     return linkTo?<Link className="link"
                          target = {target}
                          to={
                              linkTo.pathname? {
                                  pathname: linkTo.pathname,
                                  search:  linkTo.search,
                              }:linkTo
                          }>  {btn(icon,fontSize,false,className,title,showDot)}
         </Link>:btn(icon,fontSize,onClick,className,title,showDot)
}
const renderTips = (fontSize,icon,tips="",onClick=null,linkTo=null,className,title,target,showDot) =>{
   return tips?<Tooltip title={tips}>
       {renderCont(linkTo,target,icon,fontSize,onClick,className,title,showDot)}
   </Tooltip>:renderCont(linkTo,target,icon,fontSize,onClick,className,title,showDot)
}
const getAuth = (__authState=[],fontSize,icon,tips,onClick,linkTo,auth,className,title,target,showDot) =>{
    if(isEmpty(auth)){
        return renderTips(fontSize,icon,tips,onClick,linkTo,className,title,target,showDot)
    }else {
        const isHasAuth = __authState.find(item=>item==auth);
        if(isEmpty(isHasAuth)){
            return null
        }else return renderTips(fontSize,icon,tips,onClick,linkTo,className,title,target,showDot)
    }

}
const AuthBtn = ({fontSize="18px",icon="",tips="",onClick="",linkTo=null,auth=null,className="",title=null,target="_self",showDot=false}) => {
    return (<ReactContext.Consumer>
        {state=>getAuth(state.__authState,fontSize,icon,tips,onClick,linkTo,auth,className,title,target,showDot) }
    </ReactContext.Consumer>)
}

export default AuthBtn
